<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-toolbar color="orange">
        <v-toolbar-title>عمل مرتجع بيع</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        فاتورة مرتجع بيع جديدة
        <!-- <v-btn color="blue">فاتورة جديدة</v-btn> -->
        <!-- <v-btn color="blue">فاتورة قديمة</v-btn> -->
        <v-flex xs12 sm6 md3>
          <v-text-field
            height="10"
            outline
            @keyup.enter="search_fatwora_client_by_code"
            v-model="client_search_name"
            label="كود فاتورة البيع الاصلية"
          ></v-text-field>
        </v-flex>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <v-form ref="form">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex
                  xs12
                  sm6
                  md12
                  style="text-align:center;font-size: 25px;"
                >
                  <b>تفاصيل الفاتورة الاصلية </b>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <b> كود الفاتورة </b>
                  :
                  {{ mycode }}
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <b> الكود اليدوي </b>
                  :
                  {{ client_fatwora_original.code }}
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <b> السعر قبل </b>
                  :
                  {{ client_fatwora_original.price_before }}
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <b> الخصم</b>
                  :
                  {{ client_fatwora_original.discount }}
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <b> السعر النهائي </b>
                  :
                  {{ client_fatwora_original.price_after }}
                </v-flex>

                <v-flex xs12 sm6 md3>
                  <b> اسم العميل </b>
                  :
                  {{ client_fatwora_original.client_name }}
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <b> اسم السداد </b>
                  :
                  {{ client_fatwora_original.sdad_type_name }}
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <b> اسم الموظف </b>
                  :
                  {{ client_fatwora_original.emp_sales_response_name }}
                </v-flex>
                <br />
              </v-layout>
              <v-divider class=" my-2 " inset horizontal></v-divider>
              <v-layout>
                <v-flex xs12 sm6 md3>
                  <b> المجموع </b>
                  :
                  {{ client_fatwora_reback.price_before }}
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <b> القيمة المسترجعة من التخفيض </b>
                  :
                  <input
                    type="text"
                    v-model="client_fatwora_reback.reback_discount"
                  />
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <b> السعر النهائي </b>
                  :
                  {{ fatwora_final_price }}
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-autocomplete
                    outline
                    v-model="select_store"
                    :items="stores"
                    item-text="name"
                    item-value="id"
                    label="أختر  المخزن"
                    persistent-hint
                    return-object
                    single-line
                    @change="store_fatworas"
                  >
                    <template v-slot:append-outer>
                      <v-slide-x-reverse-transition mode="out-in">
                      </v-slide-x-reverse-transition>
                    </template>
                  </v-autocomplete>
                </v-flex>
              </v-layout>
              <v-divider class=" my-1" inset horizontal></v-divider>
              <v-divider class=" my-1" inset horizontal></v-divider>
              <v-data-table
                :headers="headers"
                :items="client_fatwora_reback_items"
                class="elevation-1"
                :search="search"
                :loading="loading"
                :rows-per-page-items="rowsPerPageItems"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.item_name }}</td>
                  <td>{{ props.item.item_num_before }}</td>
                  <td>
                    <input
                      style="width:50px"
                      type="number"
                      min="0"
                      :max="props.item.item_num_before"
                      v-model="props.item.item_num_reback"
                      @change="
                        check_max(props.item, props.item.item_num_before)
                      "
                    />
                  </td>
                  <td>
                    {{
                      (props.item.item_num_remain = calc_remain(
                        props.item.item_num_before,
                        props.item.item_num_after
                      ))
                    }}
                  </td>
                  <td>
                    <input
                      style="width:50px"
                      type="number"
                      min="0"
                      :max="props.item.item_num_before"
                      v-model="props.item.item_bonus"
                      @change="
                        check_max(props.item, props.item.item_num_before)
                      "
                    />
                  </td>
                  <td>{{ get_item_num_after(props.item) }}</td>
                  <td>{{ props.item.price }}</td>
                  <td>
                    {{
                      (props.item.total_price = gettotalpriceitem(
                        props.item.item_num_reback,
                        props.item.price
                      ))
                    }}
                  </td>
                </template>
              </v-data-table>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat>الغاء</v-btn>
          <v-btn color="blue darken-1" flat @click="save('form2')">حفظ</v-btn>
        </v-card-actions>
      </v-card>

      <div
        v-if="
          client_fatwora_original.fatworas_reback &&
            client_fatwora_original.fatworas_reback.length > 0
        "
      >
        <br />
        <p>فواتير المرتجعات السابقة لهذه الفاتورة</p>
        <v-data-table
          :headers="headers5"
          :items="client_fatwora_original.fatworas_reback"
          class="elevation-1"
          :search="search"
          :loading="loading"
          :rows-per-page-items="rowsPerPageItems"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.code }}</td>
            <td>{{ props.item.manual_code }}</td>
            <td>{{ props.item.price_after }}</td>
            <td>{{ props.item.emp_sales_response_name }}</td>
            <td>{{ props.item.created_at }}</td>
            <td>
              <v-btn color="red" @click="delete_reback_fatwora(props.item.id)">
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
            <td>
              <!-- dialog view order detail -->
              <v-dialog
                v-model="detail_dialog"
                width="800"
                dark
                style="padding:10px"
              >
                <template v-slot:activator="{ on }">
                  <v-icon
                    small
                    class="ml-4"
                    v-on="on"
                    @click="detailItem(props.item)"
                  >
                    book
                  </v-icon>
                </template>

                <v-card>
                  <v-card-title class="headline orange lighten-2" primary-title>
                    تفاصيل فاتورة المرتجع
                  </v-card-title>

                  <v-card-text>
                    <v-layout row>
                      <v-flex xs12 sm6 md2>
                        الكود
                        <br />
                        {{ order_detail.code }}
                      </v-flex>

                      <v-flex xs12 sm6 md2>
                        الخصم المرتجع
                        <br />
                        {{ order_detail.reback_discount }}
                      </v-flex>
                      <v-flex xs12 sm6 md2>
                        السعر قبل
                        <br />
                        {{ order_detail.price_before }}
                      </v-flex>
                      <v-flex xs12 sm6 md2>
                        السعر بعد
                        <br />
                        {{ order_detail.price_after }}
                      </v-flex>
                      <v-flex xs12 sm6 md2>
                        الموظف
                        <br />
                        {{ order_detail.emp_sales_response_name }}
                      </v-flex>
                      <v-flex xs12 sm6 md2>
                        التاريخ
                        <br />
                        {{ order_detail.created_at }}
                      </v-flex>
                    </v-layout>
                    <hr />
                    <v-data-table
                      :headers="headers6"
                      :items="order_detail.fatwora_items"
                      class="elevation-1"
                      :rows-per-page-items="rowsPerPageItems"
                    >
                      <template slot="items" slot-scope="props">
                        <td>{{ props.item.item_name }}</td>
                        <td>{{ props.item.item_num_before }}</td>
                        <td>{{ props.item.item_num_reback }}</td>
                        <td>{{ props.item.item_num_remain }}</td>
                        <td>{{ props.item.price }}</td>
                        <td>{{ props.item.total_price }}</td>
                      </template>
                    </v-data-table>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="detail_dialog = false">
                      موافق
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </td>
          </template>
        </v-data-table>
      </div>
      <p v-else>لا يوجد فواتير مرتجعات سابقة لهذه الفاتورة</p>
    </v-container>
  </div>
</template>

<script>
import {
  search_fatwora_client_by_code,
  all_reback_fatworas,
  add_client_fatwora_reback,
  delete_reback_fatwora,
  stores,
  log_me
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    search: "",
    loading: false,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    headers: [
      {
        text: "الصنف ",
        align: "right",
        value: "name",
        sortable: false
      },
      { text: "العدد", value: "phone", sortable: false, align: "right" },
      { text: "مرتجع", value: "phone", sortable: false, align: "right" },
      { text: "متبقي", value: "phone", sortable: false, align: "right" },
      {
        text: "البونص المرتجع",
        value: "phone",
        sortable: false,
        align: "right"
      },
      {
        text: "مجموع المرتجع",
        value: "phone",
        sortable: false,
        align: "right"
      },
      { text: "سعر الوحدة", value: "phone", sortable: false, align: "right" },
      { text: "مجموع المرتجع", value: "phone", sortable: false, align: "right" }
    ],
    headers5: [
      {
        text: "الكود ",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: "الكود اليدوي ",
        align: "right",
        value: "name",
        sortable: false
      },
      { text: "السعر", value: "phone", sortable: false, align: "right" },
      { text: "الموظف", value: "phone", sortable: false, align: "right" },
      { text: "التاريخ", value: "phone", sortable: false, align: "right" },
      { text: "الحذف", value: "phone", sortable: false, align: "right" },
      { text: "التفاصيل", value: "phone", sortable: false, align: "right" }
    ],
    headers6: [
      {
        text: "الصنف ",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: "العدد الاصلي",
        value: "phone",
        sortable: false,
        align: "right"
      },
      {
        text: "العدد المرتجع",
        value: "phone",
        sortable: false,
        align: "right"
      },
      {
        text: "العدد المتبقي",
        value: "phone",
        sortable: false,
        align: "right"
      },
      { text: "السعر", value: "phone", sortable: false, align: "right" },
      { text: "السعر الكلي", value: "phone", sortable: false, align: "right" }
    ],
    detail_dialog: false,
    order_detail: {},
    client_fatwora_reback_items: [],
    client_search_name: "",
    sadadstatuses: [],
    stores: [],
    select_store: { id: "" },
    all_reback_fatworas: [],
    menu2: false,
    dialog2: false,
    modal2: false,
    date2: new Date().toISOString().substr(0, 10),
    newItem: {
      id: "",
      code: "",
      paper_code: "",
      price: "",
      fatwora_dicount: "",
      final_price: "",
      madionia_before: "",
      madionia_after: "",
      client_name: "أختر المورد",
      sdad_type_name: "",
      sdad_status: "",
      emp_name: "",
      sadad_type_id: "",
      client_id: "",
      emp_id: ""
    },
    madionia: {
      madionia_before: "",
      cost_or_money: "",
      madionia_after: "",
      emp_name: "",
      type_of_operation: "",
      code_of_operation: "",
      client_id: "",
      emp_id: ""
    },
    client_fatwora_original: {},
    madionia_sabqa_of_madionia: "",
    client_fatwora_reback: {
      code: "",
      manual_code: "",
      madionia_sabqa: "",
      madionia_now: "",
      reback_discount: "",
      price_before: "",
      price_after: "",
      emp_sales_response_name: "",
      fatwora_id: "",
      store_id: "",
      client_id: "",
      emp_sales_response_id: ""
    },
    added_items: [],
    client_id: "",
    code: ""
  }),

  computed: {
    mycode() {
      if (this.all_reback_fatworas.length > 0) {
        return (this.code =
          parseInt(
            this.all_reback_fatworas[this.all_reback_fatworas.length - 1].code
          ) + 1);
      } else {
        return (this.code = 1000);
      }
    },
    calc_remain: function() {
      return function(n, m) {
        if (m != "" && isNaN(m) && m > 0) {
          return parseInt(n) - parseInt(m);
        }
        return parseInt(n);
      };
    },
    get_item_num_after: function() {
      return function(item) {
        item.item_num_after =
          parseInt(item.item_bonus) + parseInt(item.item_num_reback);

        return item.item_num_after;
      };
    },
    gettotalpriceitem: function() {
      return function(q, p) {
        if (q > 0 && p > 0) {
          return parseInt(q) * parseFloat(p);
        }
        return 0;
      };
    },

    fatwora_price() {
      let tot_price = 0;
      for (
        let index = 0;
        index < this.client_fatwora_reback_items.length;
        index++
      ) {
        tot_price += parseFloat(
          this.client_fatwora_reback_items[index].total_price
        );
      }
      if (tot_price > 0) {
        return (this.client_fatwora_reback.price = tot_price);
      }
      return 0;
    },
    fatwora_final_price() {
      if (
        this.client_fatwora_reback.price_before != "" &&
        this.client_fatwora_reback.reback_discount != ""
      ) {
        return (this.client_fatwora_reback.price_after =
          parseFloat(this.client_fatwora_reback.price_before) -
          parseFloat(this.client_fatwora_reback.reback_discount));
      }
      return (this.client_fatwora_reback.price_after = this.client_fatwora_reback.price_before);
    },
    madionia_now() {
      if (this.client_fatwora_reback.price_after > 0) {
        return (this.client_fatwora_reback.madionia_now =
          parseFloat(this.client_fatwora_reback.madionia_sabqa) -
          parseFloat(this.client_fatwora_reback.price_after));
      }
      return (this.client_fatwora_reback.madionia_now = this.client_fatwora_reback.madionia_sabqa);
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    stores().then(response => {
      this.stores = response.data;
    });
    all_reback_fatworas().then(response => {
      this.all_reback_fatworas = response.data;
    });
    this.$watch(
      "client_fatwora_reback_items",
      function() {
        this.client_fatwora_reback.price_before = 0;
        let tot_price = 0;
        for (
          let index = 0;
          index < this.client_fatwora_reback_items.length;
          index++
        ) {
          tot_price += parseFloat(
            this.client_fatwora_reback_items[index].total_price
          );
        }
        if (tot_price > 0) {
          this.client_fatwora_reback.price_before = tot_price;
        }
      },
      { deep: true }
    );
    this.$watch(
      "client_fatwora_reback.reback_discount",
      function() {
        this.fatwora_final_price;
      },
      { deep: true }
    );
  },

  methods: {
    check_max(item, q) {
      let index = this.client_fatwora_reback_items.indexOf(item);
      if (parseInt(item.item_num_reback) > parseInt(q)) {
        alert("لا يجوز ادخال قيمة اكبر من العدد الاصلي");
        this.client_fatwora_reback_items[index].item_num_reback = q;
      }
      if (parseInt(item.item_num_reback) < 0) {
        alert("لا يجوز ادخال قيمة اقل من الصفر ");
        this.client_fatwora_reback_items[index].item_num_reback = 0;
      }
    },
    initialize() {},
    detailItem(order) {
      this.order_detail = order;
    },
    code_calc() {
      if (this.client_fatworas.length > 0) {
        return (this.code =
          parseInt(this.client_fatworas[this.client_fatworas.length - 1].code) +
          1);
      } else {
        return (this.code = 1000);
      }
    },

    search_fatwora_client_by_code() {
      this.loading = true;
      search_fatwora_client_by_code(this.client_search_name).then(response => {
        this.loading = false;
        if (
          response.data.fatworas_reback &&
          response.data.fatworas_reback.length > 0 &&
          response.data.fatworas_reback[
            response.data.fatworas_reback.length - 1
          ].fatwora_items.length > 0
        ) {
          let all_of_arr = [];
          for (
            let i = 0;
            i <
            response.data.fatworas_reback[
              response.data.fatworas_reback.length - 1
            ].fatwora_items.length;
            i++
          ) {
            let in_object = {
              item_name: "",
              item_num_before: "",
              item_num_reback: "",
              item_num_remain: "",
              item_discount: "",
              item_bonus: "",
              price: "",
              total_price: "",
              final_price: "",
              item_id: ""
            };
            in_object.item_name =
              response.data.fatworas_reback[
                response.data.fatworas_reback.length - 1
              ].fatwora_items[i].item_name;
            in_object.item_num_before =
              response.data.fatworas_reback[
                response.data.fatworas_reback.length - 1
              ].fatwora_items[i].item_num_remain;
            in_object.item_num_reback = 0;
            in_object.item_num_remain =
              response.data.fatworas_reback[
                response.data.fatworas_reback.length - 1
              ].fatwora_items[i].item_num_remain;
            in_object.item_discount = 0;
            in_object.item_bonus = 0;
            in_object.item_num_after = 0;
            in_object.price =
              response.data.fatworas_reback[
                response.data.fatworas_reback.length - 1
              ].fatwora_items[i].price;
            in_object.total_price = 0;
            in_object.final_price = 0;
            in_object.item_id =
              response.data.fatworas_reback[
                response.data.fatworas_reback.length - 1
              ].fatwora_items[i].item_id;
            all_of_arr.push(in_object);
          }
          this.client_fatwora_reback_items = all_of_arr;
        } else {
          let all_of_arr = [];
          for (let j = 0; j < response.data.fatwora_items.length; j++) {
            let in_object = {
              item_name: "",
              item_num_before: "",
              item_num_reback: "",
              item_num_remain: "",
              item_discount: "",
              item_bonus: "",
              price: "",
              total_price: "",
              final_price: "",
              item_id: ""
            };
            in_object.item_name = response.data.fatwora_items[j].item_name;
            in_object.item_num_before = parseInt(
              response.data.fatwora_items[j].item_num_after
            );
            in_object.item_num_reback = 0;
            in_object.item_num_remain = parseInt(
              response.data.fatwora_items[j].item_num_after
            );
            in_object.item_discount = 0;
            in_object.item_bonus = 0;
            in_object.item_num_after = 0;
            in_object.price = response.data.fatwora_items[j].price;
            in_object.total_price = 0;
            in_object.final_price = 0;
            in_object.item_id = response.data.fatwora_items[j].item_id;
            all_of_arr.push(in_object);
          }
          this.client_fatwora_reback_items = all_of_arr;
        }
        // this.client_fatwora_reback_items = response.data.fatwora_items;
        let myUser = JSON.parse(localStorage.getItem("user"));
        // let client_id = response.data.client_id;
        this.client_fatwora_original = response.data;
        this.client_fatwora_reback.manual_code = response.data.code;
        this.client_fatwora_reback.madionia_now = "";
        this.client_fatwora_reback.reback_discount = "";
        this.client_fatwora_reback.price_before = "";
        this.client_fatwora_reback.price_after = "";
        this.client_fatwora_reback.emp_sales_response_name = myUser.name;
        this.client_fatwora_reback.fatwora_id = response.data.id;
        this.client_fatwora_reback.store_id = response.data.store_id;
        this.client_fatwora_reback.client_id = response.data.client_id;
        this.client_fatwora_reback.emp_sales_response_id = myUser.id;
        this.client_id = response.data.client_id;

        this.select_store = {
          id: response.data.store_id,
          name: this.stores.filter(st => {
            return st.id == response.data.store_id;
          })[0].name
        };

        // madionia_client(client_id).then(response => {
        //   this.client_fatwora_reback.madionia_sabqa = response.data.madionia ;
        //   this.madionia_sabqa_of_madionia = response.data.madionia ;
        // });
      });
    },

    save(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          // this.client_fatwora_reback.store_id = response.data.store_id;
          this.client_fatwora_reback.code = this.code;
          this.client_fatwora_reback.store_id = this.select_store.id;
          let myUser = JSON.parse(localStorage.getItem("user"));
          this.madionia.madionia_before = this.madionia_sabqa_of_madionia;
          this.madionia.cost_or_money = this.client_fatwora_reback.price_after;
          this.madionia.madionia_after =
            parseFloat(this.madionia_sabqa_of_madionia) -
            parseFloat(this.client_fatwora_reback.price_after);
          this.madionia.emp_name = myUser.name;
          this.madionia.type_of_operation = "back";
          this.madionia.code_of_operation = this.client_fatwora_reback.code;
          this.madionia.client_id = this.client_id;
          this.madionia.emp_id = myUser.id;

          var frmData = new FormData();
          frmData.append(
            "client_fatwora_reback",
            JSON.stringify(this.client_fatwora_reback)
          );
          frmData.append(
            "fatwora_reback_items",
            JSON.stringify(this.client_fatwora_reback_items)
          );
          frmData.append("madionia", JSON.stringify(this.madionia));

          add_client_fatwora_reback(frmData).then(response => {
            this.loading = false;
            // Object.assign(this.$data.newItem, this.$options.data().newItem);
            // Object.assign(this.$data.select_sadad_type, this.$options.data().select_sadad_type);
            // Object.assign(this.$data.select_client, this.$options.data().select_client);
            // Object.assign(this.$data.select_employer, this.$options.data().select_employer);
            // Object.assign(this.$data.added_items, this.$options.data().added_items);
            // Object.assign(this.$data.select_item, this.$options.data().select_item);
            // Object.assign(this.$data.select_sadadstatuses, this.$options.data().select_sadadstatuses);
            // Object.assign(this.$data.sadadstatuses, this.$options.data().sadadstatuses);
            // this.client_fatworas.push(response.data);
            let myUser = JSON.parse(localStorage.getItem("user"));
            var frmData3 = new FormData();
            frmData3.append("title", "فاتورة مرتجع بيع");
            frmData3.append(
              "body",
              "تم عمل فاتورة مرتجع بيع بكود " +
                this.code +
                " مرتبط بفاتورة كودها  " +
                this.client_fatwora_original.code +
                " بواسطة " +
                myUser.name
            );
            frmData3.append("type", "sell_fatwora_reback");
            frmData3.append("user_id", myUser.id);
            log_me(frmData3).then(response => {
              if (response.data == true) {
                let mytitle = "فاتورة مرتجع بيع";
                let mybody =
                  "تم عمل فاتورة مرتجع بيع بكود " +
                  this.code +
                  " مرتبط بفاتورة كودها  " +
                  this.client_fatwora_original.code +
                  " بواسطة " +
                  myUser.name;
                this.$toastr.warning(mybody, mytitle, {
                  closeButton: true,
                  progressBar: true,
                  positionClass: "toast-bottom-left",
                  preventDuplicates: false,
                  timeOut: "25000"
                });
              }
            });
            setInterval(() => {
              this.$router.go(0);
            }, 2000);
          });
        }
      });
    },
    delete_reback_fatwora(id) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          delete_reback_fatwora(id).then(res => {
            this.$swal("Deleted !", "تم حذف فاتورة المرتجع بنجاح", "success");
            setInterval(() => {
              this.$router.go(0);
            }, 2000);
          });
        }
      });
    }
  }
};
</script>

<style scope>
.v-datatable__actions {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
.flex,
.v-input.v-text-field,
.v-input__control {
  padding: 0px !important;
  margin: 0px !important;
}
.v-card__title,
.v-card__text {
  padding: 0px;
  margin: 0px;
}
</style>
